module.exports = __webpack_public_path__ + "img/content-with-img-links-kia.8f52c863.jpg";